import React from 'react';
import styled from 'styled-components';
import { translate } from '@tectonics/translate';

export const DisclaimerTermsConditions = () => {
  const termsAndConditionsUrl = 'https://www.ebanx.com/en/legal/merchants/terms-and-conditions-for-payment-processing-services/';
  return (
    <PaymentHelp>
      <WrapperIcon>
        <HelpIcon/>
      </WrapperIcon>
      <HelpText>
        {translate('volcanes.opened-payment.cryptocurrency.disclaimer1')}
        <TermsAndConditions
          href={termsAndConditionsUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {translate('volcanes.opened-payment.cryptocurrency.termsAndConditions')}
        </TermsAndConditions>
        {translate('volcanes.opened-payment.cryptocurrency.disclaimer2')}
      </HelpText>

    </PaymentHelp>
  );
};

const PaymentHelp = styled.div`
  display: flex;
  border-radius: 4px;
  gap: 12px;
  padding: 12px;
  background-color: ${props => props.theme.colors.new_primary[50]};
`;

const HelpText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
`;

const TermsAndConditions = styled.a`
  color: ${props => props.theme.colors.new_primary[700]};
  text-decoration: underline;
  cursor: pointer;
`;

const WrapperIcon = styled.div`
  width: 100%;
  max-width: max-content;
`;

const HelpIcon = () => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9 0.963379C4.02944 0.963379 0 4.99282 0 9.96338C0 14.9339 4.02944 18.9634 9 18.9634C13.9706 18.9634 18 14.9339 18 9.96338C17.9946 4.99504 13.9683 0.968753 9 0.963379ZM9 15.2134C8.37868 15.2134 7.875 14.7097 7.875 14.0884C7.875 13.4671 8.37868 12.9634 9 12.9634C9.62132 12.9634 10.125 13.4671 10.125 14.0884C10.125 14.7097 9.62132 15.2134 9 15.2134ZM9.75 11.3411C9.74986 11.0428 9.92656 10.7727 10.2 10.6534C11.5733 10.054 12.2937 8.53413 11.8878 7.09182C11.4819 5.64951 10.074 4.72787 8.58974 4.93277C7.10548 5.13767 5.99998 6.40629 6 7.90463C6 8.31884 6.33579 8.65463 6.75 8.65463C7.16421 8.65463 7.5 8.31884 7.5 7.90463C7.49961 7.15536 8.05218 6.52073 8.79438 6.41802C9.53657 6.31531 10.2407 6.77602 10.4438 7.49723C10.6469 8.21845 10.2867 8.97892 9.6 9.27863C8.77993 9.63654 8.24986 10.4464 8.25 11.3411C8.25 11.7553 8.58579 12.0911 9 12.0911C9.41421 12.0911 9.75 11.7553 9.75 11.3411Z" fill="#0040CA"/>
    </svg>
  );
};
